module.exports = __webpack_public_path__ + "images/help-videos-preview-permission-524245dafd54f4c06f05525e3a2bc3dd.png";